import React, { useState } from 'react';

export default function ProjectObjection() {
  const [formData, setFormData] = useState({
    projectId: '',
    objectionDate: '',
    objectionNo: '',
    objectorName: '',
    objectorContact: '',
    objectorEmail: '',
    objectorAddress: '',
    objectionType: '',
    affectedSurveyNo: '',
    affectedVillage: '',
    affectedTaluka: '',
    affectedDistrict: '',
    objectionCategory: '',
    objectionSummary: '',
    objectionDetails: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted Data:', formData);
    // You can replace this with your API call
  };

  return (
    <div className="max-w-5xl mx-auto p-8 mt-10 bg-white rounded-lg shadow-xl">
      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Section 1: Project & Objection Info */}
        <div>
          <h2 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">Objection Info</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input label="Project ID" name="projectId" value={formData.projectId} onChange={handleChange} required />
            <Input label="Objection Date" name="objectionDate" type="date" value={formData.objectionDate} onChange={handleChange} required />
            <Input label="Objection No" name="objectionNo" value={formData.objectionNo} onChange={handleChange} />
            <Input label="Objection Type" name="objectionType" value={formData.objectionType} onChange={handleChange} />
          </div>
        </div>

        {/* Section 2: Objector Info */}
        <div>
          <h2 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">Objector Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input label="Name" name="objectorName" value={formData.objectorName} onChange={handleChange} required />
            <Input label="Contact" name="objectorContact" value={formData.objectorContact} onChange={handleChange} />
            <Input label="Email" name="objectorEmail" type="email" value={formData.objectorEmail} onChange={handleChange} />
            <Input label="Address" name="objectorAddress" value={formData.objectorAddress} onChange={handleChange} />
          </div>
        </div>

        {/* Section 3: Affected Area */}
        <div>
          <h2 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">Affected Area</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input label="Survey No" name="affectedSurveyNo" value={formData.affectedSurveyNo} onChange={handleChange} />
            <Input label="Village" name="affectedVillage" value={formData.affectedVillage} onChange={handleChange} />
            <Input label="Taluka" name="affectedTaluka" value={formData.affectedTaluka} onChange={handleChange} />
            <Input label="District" name="affectedDistrict" value={formData.affectedDistrict} onChange={handleChange} />
          </div>
        </div>

        {/* Section 4: Objection Description */}
        <div>
          <h2 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2">Objection Content</h2>
          <div className="grid grid-cols-1 gap-4">
            <Input label="Category" name="objectionCategory" value={formData.objectionCategory} onChange={handleChange} required />
            <Textarea label="Summary" name="objectionSummary" value={formData.objectionSummary} onChange={handleChange} required />
            <Textarea label="Details" name="objectionDetails" value={formData.objectionDetails} onChange={handleChange} />
          </div>
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
          >
            Submit Objection
          </button>
        </div>
      </form>
    </div>
  );
}

// Reusable Input Component
function Input({ label, name, value, onChange, type = "text", required = false }) {
  return (
    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700 mb-1">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        required={required}
        onChange={onChange}
        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
  );
}

// Reusable Textarea Component
function Textarea({ label, name, value, onChange }) {
  return (
    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700 mb-1">{label}</label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        rows="4"
        className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
      ></textarea>
    </div>
  );
}
